mutation DeleteWidgets($ids: [ID!]!) {
  deleteWidgets(ids: $ids) {
    id
  }
}
